import { Linkedin, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const footerLinks = [
    {
      title: 'Lösungen',
      links: [
        { label: 'BESS für Rechenzentren', href: '/#why-bess' },
        { label: 'Energiemanagement', href: '/#functions' },
        { label: 'Peak Shaving', href: '/#economics' },
        { label: 'Sicherheit', href: '/#security' },
      ],
    },
    {
      title: 'Unternehmen',
      links: [
        { label: 'Implementierung', href: '/#implementation' },
        { label: 'Nachhaltigkeit', href: '/#sustainability' },
        { label: 'Fallstudien', href: '/#case-studies' },
        { label: 'Kontakt', href: '/#contact' },
      ],
    },
    {
      title: 'Ressourcen',
      links: [
        { label: 'Zukunftstrends', href: '/#future' },
        { label: 'Wirtschaftlichkeit', href: '/#economics' },
      ],
    },
    {
      title: 'Rechtliches',
      links: [
        { label: 'Datenschutz', to: '/datenschutz' },
        { label: 'Impressum', to: '/impressum' },
        { label: 'Barrierefreiheit', to: '/barrierefreiheit' },
      ],
    },
  ];

  const socialLinks = [
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Mail, href: 'mailto:info@battery-grid.io', label: 'Email' },
  ];

  return (
    <footer className="bg-muted border-t border-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 mb-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_462b1c9b-939c-4705-8ff2-b6f811719f70/artifacts/lkfe8exz_battery-grid.io.svg"
                alt="battery-grid.io"
                className="h-8"
                loading="lazy"
                data-testid="footer-logo"
              />
            </div>
            <p className="text-sm text-muted-foreground mb-6 max-w-sm">
              Innovative Energiespeicherlösungen für die Rechenzentren der
              Zukunft. Effizienz, Nachhaltigkeit und Zuverlässigkeit in einem
              System.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-9 h-9 rounded-lg bg-background border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
                  aria-label={social.label}
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Links Sections */}
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h3 className="font-heading font-semibold text-foreground mb-4">
                {section.title}
              </h3>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.to ? (
                      <Link
                        to={link.to}
                        className="text-sm text-muted-foreground hover:text-primary transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-sm text-muted-foreground hover:text-primary transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-xs sm:text-sm text-muted-foreground text-center md:text-left">
              © 2026 DSG Beteiligungs- und Verwaltungsgesellschaft mbH — Design & Umsetzung: webionik
            </p>
            <div className="flex items-center space-x-4 sm:space-x-6">
              <Link
                to="/datenschutz"
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Datenschutz
              </Link>
              <Link
                to="/impressum"
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Impressum
              </Link>
              <Link
                to="/barrierefreiheit"
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                Barrierefreiheit
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};